module.exports = __webpack_public_path__ + "img/icone_studio_bpi.61f3b438.png";